export default "__VITE_ASSET__CBcYajhV__"